import { render, staticRenderFns } from "./scdt.vue?vue&type=template&id=5dd72c44&scoped=true&"
import script from "./scdt.vue?vue&type=script&lang=js&"
export * from "./scdt.vue?vue&type=script&lang=js&"
import style0 from "./scdt.vue?vue&type=style&index=0&id=5dd72c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd72c44",
  null
  
)

export default component.exports